export const homePage = {
    numberSte: '数量： <span class="color-green">{count}</span> NFT',
    title: 'AISのNFTコレクション',
    titleContent: 'INO 購入条件：',
    lineContent1: '本人確認済み',
    lineContent2: '各アカウントで男性用シャツと女性用シャツをそれぞれ 1 枚ずつ購入します',
    buttonBuy: '購入',
    soldOut: '売り切れ',
    numberProducts: 'SL: <span class="color-red">{count}</span> NFT',
    noLoginTitle: 'ログインしていません',
    contentNoLogin: 'NFTを購入するにはログインする必要があります。',
    buttonNoLogin: 'ログイン',
    buttonVerify: '本人確認',
    changePass: 'パスワードを変更',
    logOut: 'ログアウト',
    ok: '確認',
    noVerifyTitle: '本人確認を行っていません',
    chooseWallet: '支払いウォレットを選択',
    notEnoughMoney: '残高が十分ではありません。',
    confirmBuy: 'NFT購入確認',
    price: '購入価格',
    confirmBuyButton: '購入確認',
    loginBuy: '購入ためにログイン',
    timeup: '販売は終了しました',
    remain: '残り： {remain}',
    confirmSellButton: '売ります',
    titleConnectWallet: 'ウォレットを接続してください',
    youNeedConnectMetamask: 'NFTを購入するにはウォレット接続が必要です。',
    connectWallet: 'ウォレットを接続',
    noVerifyContent: 'NFT を購入するには本人確認が必要です。',
    noVerifyButton: '認証',
    rejectVerifyTitle: 'あなたのアカウントは\nによって認証拒否されました',
    rejectVerifyContent: 'NFTを購入するには再認証が必要です',
    rejectVerifyButton: '再認定',
    pendingVerifyTitle: 'あなたのアカウントは\n認証を待っています',
    penddingVerifyButton: 'Okです',

    approvedTitle: '近日発売予定',
    approvedSubTitle1: '発売開始日:',
    approvedLine1: '2022年06月21日 08:00 UTC',
    approvedLine2: ' フェーズ2：70 NFT レディーストレーニングシャツ 2022年06月18日15時より発売',
    approvedSubTitle2: '購入条件',
    approvedLine3:
        'フェーズ3: NFT 男性トレーニングシャツ70枚、NFT 女性トレーニングシャツ30枚を2022年06月21日15:00より発売',
    approvedLine4: 'NFTの男性用シャツの合計は100、女性用シャツの合計は100です',
    approvedLine5: '各アカウントで男性用シャツと女性用シャツをそれぞれ 1 枚ずつ購入します',
    approvedLine6: 'アカウント登録及び本人確認済み',
    approvedButton: 'Okです',

    connectPayButton: 'ウォレットを接続',
    pedding: '認証待ち',
    peddingTitle: 'あなたのアカウントは\n認証を待っています',
    successVerifyTitle: 'あなたのアカウントは\nによる認証されました',
    successVerifyButton: 'Okです',
    message: {
        titleConnectWallet: 'ウォレットを接続。',
        deviceNotSupport: 'デバイスはサポートされていません。',
        connectFail: '接続に失敗しました。',
        opened: 'メタマスク ウィンドウを開いてログインを確認してください。',
    },
    buttonRegister: 'すぐに登録',
    buttonTextVerify: 'すぐに認証',
    newItemTitle: '最新ニュース',
    walletTitle: 'ウォレット',
    walletBalance: '残高',
    loadWallet: '入れる',
    loadWalletTitle: '入れる',
    loadWalletContent: 'BNB Smart Chain (BEP20)',
    loadWalletSubContent: 'AIS、SB、BNB、USDT をこの正しいウォレット アドレスに送信します。',
    walletAddress: 'ウォレット アドレス',
    scanAddress: 'アドレスをスキャンして支払いを受け取ります',
    withdrawWallet: '撤回',
    withdrawWalletTitle: 'STE撤回',
    commonSoon: '近日公開',
    okie: 'Okです',
    copyAddress: 'ウォレットアドレスが成功にコピーされました',
    productTitle: 'AIS のNFTコレクション',
    remainTimeBuy: '残り販売時間： ',
    bannerTitle: '最高のプレミアム、ユニーク、独占的な NFT コレクションを発見します',
    line1: '2022年06月21日 08:00 UTC',
    line2: ' フェーズ2：70 NFT レディーストレーニングシャツ 2022年06月18日15時より発売',
    bannerSubTitle: '購入条件',
    line3: 'フェーズ3: NFT 男性トレーニングシャツ70枚、NFT 女性トレーニングシャツ30枚を2022年06月21日15:00より発売',
    line4: 'NFTの男性用シャツの合計は100、女性用シャツの合計は100です',
    line5: '各アカウントで男性用シャツと女性用シャツをそれぞれ 1 枚ずつ購入します',
    line6: 'アカウント登録及び本人確認済み',
    haveOwned: '所有済み',
    modalFire: {
        title: 'おめでとう！',
        subTitle: 'INO STE ステージ <span>{count}</span> は終了しました',
        content1: 'メンバーの皆様、NFT STE の\n 所有に成功しましたおめでとうございます',
        content2:
            ' 今回は運が悪かった場合は、ステージに参加してください <span>{count}</span> 15:00 (VN)に',
        stage1: ' 06月18日に行きましょう',
        stage2: ' 06月21日に行きましょう',
    },
    coming_soon: '近日公開',
    download: 'ダウンロード',


    filter_order: '手配',
    filter_nft: 'NFTタイプでフィルタリングします',
    filter_mint: 'ミント回でフィルタリングします',
    filter_token: 'トーケンタイプでフィルタリングします',
    newest: '最新',
    price_asc: '価格: 安いから高いまで ↑',
    price_desc: '価格: 高いから安いまで ↓',
    all: 'すべて',
    nft_m: 'NFT M',
    nft_w: 'NFT W',
    nft_s: 'NFT S',
    nft_us: 'NFT US',
    nft_os: 'NFT OS',
    mint_couple: 'ミントのペア',
    last1: 'あと1回',
    last2: 'あと2回',
    last3: 'あと3回',
    last4: 'あと4回',
    last5: 'あと5回',
    last6: 'あと6回',
    last7: 'あと7回',
    new: '新しい',
    expire: 'エクササイズの有効期限が切れ',
    cancel_sell: '販売をキャンセル',
    confirm_cancel: 'NFT販売をキャンセル',
    price_sell: '販売価格：',
    fee: '販売手数料5％：',
    ste_receive: '{0} 数を受け取ります:',
    couple_des: 'ミントされたNFTはペアで取引する必要があります (NFT M 及び NFT W)。',
    invite: '友達を紹介',
    invite_title: '友達を招待',
    rule: '規定',
    rule1: '紹介・リンク ID をアカウントを持っていない友人と共有します',
    rule2: '紹介された者は成功に本人確認をし、練習に参加する必要があります',
    rule3: '紹介が成功するたびに、さらに 4 日間の無料プレイが得られます',
    id_invite: 'あなたの紹介ID',
    linkref: '招待リンク',
    ref_code: '紹介コード',
    copy_success: 'コピーが成功しました！',
    condition_sell: 'NFTの販売条件',
    condition_sell1: '1. NFTは新品（未使用）です。',
    condition_sell2: '2. 使用されたNFTは7回以上の受賞が必要（7回未満のNFTは販売不可）',
    condition_sell3: '3. ミントされたNFT はペアで取引する必要があります (NFT M および NFT W)。',
    condition_sell4: '4. 販売に投稿されたときに7回以上使用され、報酬を受け取ったNFTは、有効期限までカウントされ続けます。誰かが購入すると、有効期限は自動的に期限切れになります。販売者が販売をキャンセルした場合、有効期限はカウントされる日数と同じになります。\n',
    condition_sell5: '5. 販売用にリストされている NFT を練習に使用してはいけない。\n',
    condition_sell6: '6. 使用されたNFTはミント回数を残っている必要があります。',
    nft_not_mint: 'ミントされていないNFT',
    sell: '販売',
    confirm_sell: 'NFTの販売確認',
    transfer_confirm: 'NFTの転送確認',
    fee_transfer: '転送手数料：',
    sell_placeholder: '販売価格を入力',
    valid_price: '販売価格を入力してしださい',
    priceSellRequired: '販売価格を入力してしださい',
    confirm_text: '確認',
    change_price: '価格を変更',
    change_price_title: 'NFTの販売価格を変更',
    sell_success: 'NFTは成功に販売されました！',
    nft_minted: 'ミントされたNFT',
    history_title: '履歴',
    history_text: '取引履歴',
    nft_transaction: 'NFT取引',
    ste_transaction: 'STE取引',
    stt: 'STT',
    time: '時間',
    type_transaction: '取引タイプ',
    type_nft: 'NFTタイプ',
    id_nft: 'ID NFT',
    price_nft: '価格',
    transfer_nft: '送信者・受取者',
    fee_nft: '手数料',
    type_wallet: 'ウォレットタイプ',
    total: '金額',
    hash: 'ハッシュ',
    wallet_to: '受信のウォレットアドレス',
    status: 'スターテス',
    copySuccess: 'コピーが成功しました！',
    copyFail: 'コピーが失敗しました',
    not_available: 'NFTが販売されているか、または利用不可です！',
    transfer: "転送",
    collaborators_title: "協力者"
};
